import { Fragment } from "react";
import './titolo.css'
import TemporaryDrawer from "./bottoni";


function Titolo() {
    return(<Fragment>
        <div style={{ width: "100", color: "white" }}>
          <h1 id="titoloAzienda" style={{ display: "2" }}>
          MARCO GOMME
          </h1>
          <br/>
          <br/>
          <br/>
          <br/>
         <TemporaryDrawer/>
        </div>
    </Fragment>)
}

export default Titolo